export const STAGING_BASE_URL = 'http://localhost:8888'
export const BASE_URL = 'https://stupendous-youtiao-7e64f6.netlify.app'

export const API_SUBMIT_FORM = '/.netlify/functions/sendEmail'

export const CALANDLY_MEET = 'https://calendly.com/onlinebadho/landing-page-discussion';